import React, { useState } from 'react';
import { Accordion, AccordionDetails, IconButton } from '@mui/material';
import { withStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import SimpleButton from '../SimpleButton/SimpleButton';
import styles from './AccordionGray.module.scss';

const CustomAccordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    '&:not($expanded):not(:last-child)': {
      borderBottom: 0,
    },
  },
  expanded: {
    margin: '0 !important',
  },
})(Accordion);

const CustomAccordionDetails = withStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: theme.spacing(1),
    padding: theme.spacing(1),
  },
}))(AccordionDetails);

type AccordionGrayProps = {
  children: React.ReactNode;
  onDelete?: () => void;
  extraClass?: string;
  id: string;
  onChange?: () => void;
  title: string;
  defaultExpanded?: boolean;
};

const AccordionGray: React.FC<AccordionGrayProps> = (props) => {
  const { children, onDelete = null, extraClass, id, onChange, title, defaultExpanded = false } = props;
  const [expanded, setExpanded] = useState(defaultExpanded);
  const { t } = useTranslation();

  return (
    <CustomAccordion data-testid={id} expanded={expanded} onChange={onChange} square elevation={0}>
      <div className={styles.AccordionHeader}>
        <section className={onDelete ? '' : 'w-100'}>
          <IconButton data-qa={`expand-button-${id}`} data-testid={`${id}-expand-button`} size="small" onClick={() => setExpanded(!expanded)}>
            {expanded && <i className={`di icon-pfeil-chevron-oben ${styles.Icon} `} />}
            {!expanded && <i className={`di icon-pfeil-chevron-unten ${styles.Icon} `} />}
          </IconButton>
          <span className={`${styles.Title} ${extraClass}`}>{title}</span>
        </section>
        {onDelete && (
          <SimpleButton id="accordeon-button" color="primary" buttonText={t('dialog.delete')} handleClick={onDelete} />
        )}
      </div>
      <CustomAccordionDetails data-testid={`${id}-details`}>{children}</CustomAccordionDetails>
    </CustomAccordion>
  );
};

export default AccordionGray;
